import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { db } from '../../firebaseConfig';
import { addDoc, doc, getDoc, updateDoc } from 'firebase/firestore';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  CardActions,
  Box,
  Rating,
  Avatar
} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalMallIcon from '@mui/icons-material/LocalMall';

const OneProduct = ({ product }) => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const prodId = product.phone;

  const handleAddToCart = async () => {
    try {
      const cartRef = doc(db, 'cart', userId);
      const cartDoc = await getDoc(cartRef);
      if (cartDoc.exists()) {
        const cartData = cartDoc.data();
        cartData.cart.push(product);
        await updateDoc(cartRef, { cart: cartData.cart });
      } else {
        const newCartData = { cart: [product] };
        await addDoc(cartRef, newCartData);
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  };

  const handleBuyNow = () => {
    navigate(`/store/${userId}/${prodId}`, { state: { product } });
  };

  return (
    <Card sx={{ maxWidth: 345, boxShadow: 3, borderRadius: 3, padding: 2 }}>
      <CardMedia
        component="img"
        height="300"
        image={product.img}
        alt={product.badge}
        sx={{ borderRadius: 2 }}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {product.badge}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {product.desc}
        </Typography>
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Typography variant="h6" color="primary">
          ₹{product.price}
          </Typography>
          <Box display="flex" alignItems="center">
            <Avatar sx={{ width: 24, height: 24, mr: 1 }}>{product.seller[0]}</Avatar>
            <Typography variant="body2">{product.seller}</Typography>
          </Box>
        </Box>
        <Rating
          name="seller-rating"
          value={product.sellerRating}
          precision={0.5}
          readOnly
          sx={{ mb: 2 }}
        />
      </CardContent>
      <CardActions>
        <Button
          variant="outlined"
          startIcon={<ShoppingCartIcon />}
          onClick={handleAddToCart}
          sx={{ flexGrow: 1 }}
        >
          Add to cart
        </Button>
        <Button
          variant="contained"
          startIcon={<LocalMallIcon />}
          onClick={handleBuyNow}
          sx={{ flexGrow: 1, ml: 1 }}
        >
          Buy Now
        </Button>
      </CardActions>
    </Card>
  );
};

export default OneProduct;
